import { useDispatch } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { PaymentPlansService } from '../services';

/**
 * React Query hook to fetch payment plans
 *
 * @param {Object} [options] - Hook options
 * @param {boolean} [options.refetchOnWindowFocus=false] - Whether to refetch when window regains focus
 */
export const useGetPaymentPlans = (options) => {
  const dispatch = useDispatch();

  const { data, error, isFetching, isLoading, isError } = useQuery({
    queryKey: ['GET_PAYMENT_PLANS'],
    queryFn: async () => {
      dispatch({ type: 'GET_PAYMENT_PLANS_REQUEST' });

      return PaymentPlansService.getPaymentPlans().finally(() =>
        dispatch({ type: 'GET_PAYMENT_PLANS_SUCCESS' }),
      );
    },
    retry: false,
    refetchOnWindowFocus: options?.refetchOnWindowFocus ?? false,
  });

  return {
    data: data?.data || [],
    error,
    isError,
    isInitialLoading: isLoading,
    isLoading: isLoading || isFetching,
  };
};
